import { createFileRoute } from "@tanstack/react-router";
import { useSEO } from "../hooks/useSEO";
import { SEO_CONFIG } from "../seo/seoConfig";
import { JsonLd } from "../seo/JsonLd";
import { definedTermSetSchema } from "../seo/schemas";
import { Breadcrumb } from "../components/shared/Breadcrumb";
import { GLOSSARY_TERMS } from "../data/glossary";

export const Route = createFileRoute("/glossary")({
  component: GlossaryPage,
});

function GlossaryPage() {
  useSEO(SEO_CONFIG["/glossary"]!);

  return (
    <div className="min-h-screen bg-white">
      <JsonLd
        data={definedTermSetSchema({
          name: "Marketing Analytics Glossary",
          description:
            "Definitions of marketing analytics and client-reporting terms — KPIs, attribution, ROAS, Core Web Vitals, MCP, and more.",
          terms: GLOSSARY_TERMS.map((t) => ({ name: t.term, description: t.definition })),
        })}
      />
      <div className="mx-auto max-w-3xl px-4 py-12 sm:py-16">
        <div className="mb-6">
          <Breadcrumb items={[{ name: "Home", url: "/" }, { name: "Glossary", url: "/glossary" }]} />
        </div>

        <h1 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
          Marketing Analytics Glossary
        </h1>
        <p className="mt-3 text-lg text-foreground/80">
          Clear definitions of the terms that show up in marketing analytics and agency client reporting.
        </p>

        {/* Quick jump index */}
        <nav aria-label="Glossary terms" className="mt-6 flex flex-wrap gap-x-3 gap-y-1 text-sm">
          {GLOSSARY_TERMS.map((t) => (
            <a key={t.anchor} href={`#${t.anchor}`} className="text-brand hover:underline">
              {t.term}
            </a>
          ))}
        </nav>

        <dl className="mt-10 space-y-8">
          {GLOSSARY_TERMS.map((t) => (
            <div key={t.anchor}>
              <dt id={t.anchor} className="scroll-mt-24 text-xl font-semibold tracking-tight text-foreground">
                {t.term}
              </dt>
              <dd className="mt-2 text-[17px] leading-relaxed text-foreground/90">{t.definition}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
